module.exports = ( $scope, $uibModalInstance, checks ) ->

  $scope.cancel = ->
    $uibModalInstance.dismiss( 'cancel' )
    return

  $scope.ok = ->
    $uibModalInstance.close( null )

  $scope.checks = checks
